<template>
    <div>
        <Title title="单场精选" :path="formPath" :tablist="tabs" :tabactive="tab_active" @titleTabActive="titleTabActive"/>

<!--        <div class="fxboex tabpanel">-->
<!--            <van-tabs v-model="tab_active">-->
<!--                <van-tab v-for="(c, i) in tabs" :key="i" :title="c"/>-->
<!--            </van-tabs>-->
<!--        </div>-->
<!--        <div class="tabpanel_lh"></div>-->

        <div class="page-loading" v-if="isInit === true">
            <van-skeleton title :row="8" />
        </div>
        <template v-else>
            <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
                <van-list v-model="isLoading"
                          finished-text="没有了~"
                          :immediate-check="false"
                          :finished="isFinished"
                          :error.sync="isError"
                          :error-text="match.list.length>0?'读取失败':''"
                          @load="onLoadMore">
                    <match_mini :data="match"/>
                </van-list>
            </van-pull-refresh>
        </template>
    </div>
</template>

<script>
    import match_mini from './public/match_mini'
    import Title from './public/title'
    export default {
        name: "dan",
        components: {
            match_mini,
            Title
        },
        data() {
            return {
                match: {'type': 1, 'list': []},
                tabs: ['足球精选', '篮球精选'],
                tab_active: 0,
                ball: 1,
                page: 1,
                isInit: true,
                isRefresh: false,
                isLoading: false,
                isLoadingError: false,
                isFinished: false,
                isError: false,
                formPath: ''
            }
        },
        watch: {
            // '$route': {
            //     handler: function () {
            //         this.ball = this.$route.meta.ball
            //         if(this.ball) {
            //             this.tab_active = this.ball - 1
            //             this.isInit = true
            //             this.paramInit()
            //             this.getdata()
            //         }
            //     }
            // },
            // tab_active(i){
            //     this.ball = i+1
            //     this.paramInit()
            //     this.getdata()
            // }
        },
        activated() {
            let that = this
            that.ball = that.$route.meta.ball
            that.getdata()
        },
        // mounted() {
        //     if(this.$route.meta.y) {
        //         document.documentElement.scrollTop = this.$route.meta.y
        //         console.log(2)
        //     }
        // },
        methods: {
            titleTabActive(i){
                this.tab_active = i
                this.ball = i+1
                this.paramInit()
                this.getdata()
            },
            paramInit(){
                this.page = 1
                this.isRefresh = false
                this.isLoading = false
                this.isFinished = false
                this.isError = false
                this.$backTop()
            },
            onRefresh(){
                let that = this
                this.page = 1
                this.isLoading = false
                this.isFinished = false
                this.isError = false
                setTimeout(function () {
                    that.getdata()
                }, 200)
            },
            onLoadMore(){
                let that = this
                if(!that.isLoadingError)
                    that.page++
                that.getdata()
            },
            getdata(){
                let that = this
                that.$get(that.$api.dan_list,{ball: that.ball, page: that.page})
                    .then(function (res) {
                        if(res.code === 1) {
                            if(that.page === 1){
                                that.match.list = []
                                that.$backTop()
                            }
                            let tmplist = res.data.list
                            if(tmplist.length > 0) {
                                if (that.isRefresh) {
                                    that.match.list = tmplist
                                } else {
                                    that.match.list = that.match.list.concat(tmplist)
                                }
                            }
                            else{
                                that.isFinished = true
                            }
                            that.isInit = false
                        }
                        else{
                            that.isError = true
                        }
                    })
                    .catch(function () {
                        that.isError = true
                        that.isLoadingError = true
                    })
                    .finally(function () {
                        that.isRefresh = false
                        that.isLoading = false
                    })
            },
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path === '/' ?'/free':''
            })
        }
    }
</script>

<style scoped>
</style>
